import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WArticleBodyImageCCD: IClientComponentDefinition = {
  name: 'WArticleBodyImage',
  load: () => import(/* webpackChunkName: 'WArticleBodyImage' */ './index'),
}
